import { render, staticRenderFns } from "./FooterCommonGlobal.vue?vue&type=template&id=66016328&scoped=true&"
import script from "./FooterCommonGlobal.vue?vue&type=script&lang=js&"
export * from "./FooterCommonGlobal.vue?vue&type=script&lang=js&"
import style0 from "./FooterCommonGlobal.vue?vue&type=style&index=0&id=66016328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66016328",
  null
  
)

component.options.__file = "FooterCommonGlobal.vue"
export default component.exports